import { LocalStorage } from 'src/common/helpers/local-storage';
import { createSpan, endSpan } from 'src/common/helpers/tracing-helper';
import { POSModeActions } from 'src/common/redux/reducers/pos-mode-reducer';
import { initializeDevices } from '../../common/device/initialize-devices';
import { store } from '../../common/redux/configure-store';
import { getPeripheralAlterTemplate } from '../../home-page/business-logic/get-alert-template';
import { getLatestTransaction } from '../../home-page/business-logic/get-latest-transanction';
import { getPLUmenu } from '../../home-page/business-logic/get-plu-menu';
import { touchpointStartup } from './service/touchpoint-startup';
import { updateTouchPointConfiguration } from './touchpoint-configuration';
import { touchpointLogin } from './touchpoint-login';

export const startTouchpoint = async (): Promise<void> => {
  const span = createSpan('start-touchpoint');
  await touchpointStartup();
  await appStartup();
  await initializeDevices(true);

  setPosModeForLockedUser();

  //get plu menu after login for RTI, but regardless of next gen or not
  await getPLUmenu();
  endSpan(span);
};

const appStartup = async (): Promise<void> => {
  await touchpointLogin();
  // ColdStartInprogressHandler:  GetDmsConfiguration rti is used to determine weather coldStart is needed
  await updateTouchPointConfiguration();

  // GetKeyboardConfigurationHandler: KeyboardConfigurationLookup.rti
  // RegisterLanguageDictionariesHandler: LocalizedResourceLookup.rti has been called to build localized dictionary, HierarchyCultureLookup.rti also been called to buidl culture
  // GetDynamicXamlsPartsHandler: PosStateLookUp.rti to get App View state, and each state calls CustomerDisplayLayoutLookup.rti
  // ImageLoaderHandler: BusinessUnitImageLookup.rti to get store LOGO
  // GetOwnBagConfigurationHandler: OwnBagConfigurationLookup.rti
  // TODO integrate the price override types with the overall command menu request coming in the future

  await getPeripheralAlterTemplate();
  await getLatestTransaction();

  // EpsInitializationHandler: initialize Electronic payment system
};

const setPosModeForLockedUser = (): void => {
  const lockedUser = LocalStorage.getLockUserObject();
  if (lockedUser) {
    store.dispatch(POSModeActions.setTrainingState(lockedUser.trainingMode ?? false));
  }
};
